import { Moeda } from "../gerenciamento/moeda.model";

export class Laminas {
  public Id: number | string;
  public Nome: String;
  public Formato: String;
  public URL: String;
  public Validade: String;
  public Deletado: boolean;
  public DeletadoPor: String;
  public DeletadoEm: String;
}

export class ItemLamina{
  AereoId: number;
  HotelId: number;
  Pagamentos: PagamentoLamina;
  ImagemId: number;
  TemplateId: number;
  UtilizarLogoAgencia: boolean = true;
  FraseOpcional: string = "";
  NomeHotel: string = "";
  Traducao: string = "pt";
  ImagemURL: string = "";
  buscaApi: boolean = true;
}

export class PagamentoLamina{
  FormaPagamento:any;
  CondicaoPagamento:any;
  CambioPagamento:Moeda;
  SimboloCambio: any;
  ValorAereo: any;
  ValorHotel: any;
  ValorTotal: number;
  Coeficiente: number;
  Parcelas: any;
  ValorParcelas: any;
  QntdAdtAereo: number;
  QntdAdtHotel: number;
  ValorPorPessoa: Boolean = true;
}
export class Steps {
  FirstStep: boolean = false;
  SecondStep: boolean = false;
  ThirdStep: boolean = false;
  FourthStep: boolean = false;
}
